"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var spaui_1 = require("@tencent/spaui");
var HelpTips = function HelpTips(props, ref) {
  var _a = props.OverlayTriggerProps,
    overlayTriggerProps = _a === void 0 ? {} : _a,
    _b = props.PopOverProps,
    popOverProps = _b === void 0 ? {} : _b,
    className = props.className,
    _c = props.noIcon,
    noIcon = _c === void 0 ? false : _c,
    label = props.label,
    children = props.children,
    style = props.style,
    tips = props.tips,
    _d = props.show,
    show = _d === void 0 ? true : _d,
    _e = props.inline,
    inline = _e === void 0 ? true : _e,
    _f = props.valign,
    valign = _f === void 0 ? -2 : _f,
    icon = props.icon,
    onMouseOver = props.onMouseOver,
    onMouseOut = props.onMouseOut,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave;
  var tmpicon;
  var content;
  var triggerContent;
  if (!show) {
    return null;
  }
  var svghelp = icon || react_1["default"].createElement("svg", {
    viewBox: "0 0 13 13",
    focusable: "false",
    width: "13",
    height: "13",
    xmlns: "http://www.w3.org/2000/svg",
    className: "odc-svg-help"
  }, react_1["default"].createElement("path", {
    d: "M6.5 0C10.084 0 13 2.916 13 6.5S10.084 13 6.5 13A6.508 6.508 0 0 1 0 6.5C0 2.916 2.916 0 6.5 0zm.504 9.332h-1v1.546h1V9.332zm1.33-6.145c-.87-.844-2.257-.927-3.205-.267-.823.573-1.123 1.36-1.121 2.603l1-.001.002-.196c.024-.82.215-1.255.69-1.585.563-.392 1.417-.34 1.937.164.495.48.473 1.59.011 2.013-.248.226-1.02.786-1.135.895a1.2 1.2 0 0 0-.332.486c-.105.308-.152.751-.152 1.35h1l.002-.18c.008-.402.042-.688.096-.845a.313.313 0 0 1 .073-.085c.053-.05.817-.604 1.123-.884.885-.81.92-2.585.01-3.468z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
  if (noIcon === false) {
    tmpicon = react_1["default"].createElement("i", {
      className: (0, classnames_1["default"])('odc-help-tips cursor-pointer', {
        'ml-4': inline
      }, "align-".concat(valign), className),
      style: style,
      ref: ref,
      onMouseOver: onMouseOver,
      onMouseOut: onMouseOut,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    }, svghelp);
  }
  if (children) {
    triggerContent = children;
  } else {
    if (label) {
      content = typeof label === 'string' ? react_1["default"].createElement("span", {
        className: "help-tips-label"
      }, label) : label;
      triggerContent = tmpicon ? react_1["default"].createElement("span", {
        className: "help-tips-group"
      }, content, tmpicon) : content;
    } else {
      triggerContent = tmpicon;
    }
  }
  if (children && !tips) {
    return children;
  }
  return react_1["default"].createElement(spaui_1.OverlayTrigger, __assign({
    trigger: "hover",
    overlay: react_1["default"].createElement(spaui_1.PopOver, __assign({
      gap: 4
    }, popOverProps), tips),
    placement: "top",
    disabled: !tips
  }, overlayTriggerProps), triggerContent, typeof children === 'undefined' || !children ? icon : null);
};
(0, spaui_utils_1.setComponentMark)(HelpTips, info_1["default"]);
exports["default"] = react_1["default"].memo(react_1["default"].forwardRef(HelpTips));